import quotesRender from "@/common/const/elementsList/quotesRender.const";
import quoteTypeVariant from "@/common/const/quote/quoteVariants";
import { QuotesType } from "@/common/types";
import { QuoteCreationFirstStepType } from "@/common/types/quote";
import Typography from "@/components/Typography/Typography";
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import { isString } from "lodash";
import { useEffect, useState } from "react";

const stateKeys = ["firstStepData", "secondStepData"] as const;
type StateKeys = (typeof stateKeys)[number];
interface QuoteModalFirstStepProps {
  firstStepState: QuoteCreationFirstStepType;
  updateFunc: (parentName: StateKeys, fieldName: string, value: any) => void;
  validationErr: Record<string, string>;
  removeErrors: (fieldName: string) => void;
}
export default function QuoteModalFirstStep({
  firstStepState,
  updateFunc,
  validationErr,
  removeErrors,
}: QuoteModalFirstStepProps) {
  const [productTypeOptions, setProductTypeOptions] =
    useState<{ label: string; value: QuotesType }[]>(quotesRender);
  useEffect(() => {
    const productType =
      firstStepState.quoteCreatingType === "multiSiteQuote"
        ? quotesRender.slice(0, -3)
        : quotesRender;
    setProductTypeOptions(productType);
  }, [firstStepState.quoteCreatingType]);

  return (
    <div className="mt-8 flex flex-col gap-4 ">
      <div className="flex flex-col gap-1">
        <Typography type="span" fontFamily="font-kanit" fontWeight="font-light">
          Select type{" "}
          <Typography type="span" textColor="red-main">
            *
          </Typography>
        </Typography>
        <Select
          value={firstStepState.quoteCreatingType}
          className="h-10 bg-gray-border rounded-lg min-w-[360px]"
          onChange={(value: string) =>
            updateFunc("firstStepData", "quoteCreatingType", value)
          }
          options={quoteTypeVariant.map((el) => ({
            label:
              el === "multiSiteQuote"
                ? "Multi Site Quote"
                : "Single Site Quote",
            value: el,
          }))}
        />
      </div>
      <div className="flex flex-col gap-1">
        <Typography type="span" fontFamily="font-kanit" fontWeight="font-light">
          Select product type
          <Typography type="span" textColor="red-main">
            *
          </Typography>
        </Typography>
        <Select
          options={productTypeOptions}
          value={firstStepState.productType}
          onChange={(value: string) => {
            updateFunc("firstStepData", "productType", value);
            removeErrors("productType");
          }}
          className="h-10 bg-gray-border rounded-lg min-w-[360px]"
        />
        {isString(validationErr?.productType) && (
          <Typography type="span" fontFamily="font-kanit" textColor="red-main">
            {validationErr?.productType}
          </Typography>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4 w-full mb-2 ">
        <div>
          <Typography
            type="span"
            fontFamily="font-kanit"
            fontWeight="font-light"
          >
            Due date
            <Typography type="span" textColor="red-main">
              *
            </Typography>
          </Typography>
          <DatePicker
            className="w-full h-[46px] rounded-lg bg-gray-border  text-base font-kanit !border-none !text-black hover:bg-primaryDim"
            placeholder={"Due data"}
            format={"YYYY-MM-DD"}
            allowClear={false}
            minDate={dayjs(Date.now())}
            defaultValue={dayjs().add(2, "day")}
            onChange={(value) => {
              updateFunc(
                "firstStepData",
                "dueDate",
                dayjs(value).toISOString()
              );
              removeErrors("dueDate");
            }}
          />
          {isString(validationErr.dueDate) && (
            <Typography
              type="span"
              fontFamily="font-kanit"
              textColor="red-main"
            >
              {validationErr.dueDate}
            </Typography>
          )}
        </div>
        <div>
          <Typography
            type="span"
            fontFamily="font-kanit"
            fontWeight="font-light"
          >
            RFS date
            <Typography type="span" textColor="red-main">
              *
            </Typography>
          </Typography>
          <DatePicker
            className="w-full h-[46px] rounded-lg bg-gray-border max-w-1/2 text-base font-kanit !border-none !text-black hover:bg-primaryDim"
            placeholder={"Due data"}
            format={"YYYY-MM-DD"}
            allowClear={false}
            minDate={dayjs(Date.now())}
            defaultValue={dayjs().add(7, "day")}
            onChange={(value) => {
              updateFunc(
                "firstStepData",
                "RFSdate",
                dayjs(value).toISOString()
              );
              removeErrors("RFSdate");
            }}
          />
          {isString(validationErr.RFSdate) && (
            <Typography
              type="span"
              fontFamily="font-kanit"
              textColor="red-main"
            >
              {validationErr.RFSdate}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
